//-- Copyright (c) 2021 TMT Insights Group, LLC
import { TitleConfig } from '@tmt-insights/oms_fe_core';

const titleConfig: TitleConfig = {
  customerLabel: 'vendor'
};

export default titleConfig;
